import BaseLayout from '@layouts/Base';
import MainLayout from '@layouts/MainLayout';
import Homepage from '@views/HomePage';
import Home from '@views/Home/index';
import Test from '@views/Test';
import Video from '@views/Video';
import PlaybackPlayer from '@views/Video/Playback';
import Analysis from '@views/Analysis';
import UserCenter from '@views/UserCenter';
import ReplayList from '@views/ReplayList';
import Login from '@views/Login';
import ForgetPassword from '@views/ForgetPassword';
import Register from '@views/Register';
import PublicClass from '@views/PublicClass';

const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: Homepage
    },
    {
        path: '/home',
        component: BaseLayout,
        children: [
            {
                path: '/home',
                component: MainLayout,
                children: [
                    {
                        path: '/home',
                        name: 'Home',
                        component: Home
                    },
                    {
                        path: '/replaylist',
                        name: 'ReplayList',
                        component: ReplayList
                    },
                    {
                        path: '/usercenter',
                        name: 'UserCenter',
                        component: UserCenter
                    }
                ]
            },
            {
                path: '/test',
                name: 'Test',
                component: Test
            },
            {
                path: '/video',
                name: 'Video',
                component: Video
            },
            {
                path: '/video/playback',
                name: 'PlaybackPlayer',
                component: PlaybackPlayer
            },
            {
                path: '/analysis',
                name: 'Analysis',
                component: Analysis
            },
            {
                path: '/login',
                name: 'Login',
                component: Login
            },
            {
                path: '/forget',
                name: 'ForgetPassword',
                component: ForgetPassword
            },
            {
                path: '/register',
                name: 'Register',
                component: Register
            },
            {
                path: '/publicclass',
                name: 'PublicClass',
                component: PublicClass
            }
        ]
    }
];

export default routes;
